import styles from 'styles/components/pages/student/patientDetail/PatientCard.module.scss';
import { ReactComponent as ChevronRightIcon } from 'assets/icons/chevron_right.svg';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import { Link, useParams } from 'react-router-dom';
import { ROUTE_PATH } from 'constants/routePath';
import { TPatientCardInfo } from 'types/apis/patient';
import useModal from 'hooks/useModal';
import CheckPatientComplaint from 'pages/modal/CheckPatientComplaint';

type TProps = {
  patientInfo: TPatientCardInfo;
};

const PatientCard = ({ patientInfo }: TProps) => {
  const { openModal } = useModal();
  const { id } = useParams();
  const patientId = id as string;

  const onClickCheckComplaint = () => {
    openModal({
      element: <CheckPatientComplaint text={patientInfo.complaint} />,
    });
  };

  return (
    <div>
      <div className={styles.info_card}>
        <div className={styles.title_wrapper}>
          <h2 className={styles.title}>대상자 상세 정보</h2>
          <Link
            to={`${ROUTE_PATH.student.PATIENT_REGISTER}/${patientId}`}
            className={styles.btn}
          >
            기존 정보 수정하기
            <ChevronRightIcon
              fill={STYLES_VARIABLES.GRAY_07}
              width={16}
              height={16}
            />
          </Link>
        </div>
        <div className={styles.info_items}>
          <div className="w100">
            <p className="fs18 fw700">이름</p>
            <p className="mt16 text_right">{patientInfo.name}</p>
          </div>
          <p className={styles.border}></p>
          <div className="w100">
            <p className="fs18 fw700">나이(성별)</p>
            <p className="mt16 text_right">{patientInfo.ageAndSex}</p>
          </div>
          <p className={styles.border}></p>
          <div className="w100">
            <p className="fs18 fw700">개인정보동의서</p>
            <p className="mt16 text_right">{patientInfo.agreeOrNot}</p>
          </div>
          <p className={styles.border}></p>
          <div className="w100 relative">
            <p className="fs18 fw700">주요 호소 증상</p>
            <button
              className={styles.check_btn}
              onClick={onClickCheckComplaint}
            >
              <span className="fs12 fw700 font_purple">확인하기</span>
              <ChevronRightIcon
                width={18}
                height={18}
                fill={STYLES_VARIABLES.PURPLE_01}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientCard;
